import { useEffect, useState } from 'react'
import { fetchBrands } from 'repos/brand'
import { BrandType } from 'types/brand'

const useFetchBrands = () => {
  const [brands, setBrands] = useState<BrandType[]>([])

  useEffect(() => {
    ;(async () => {
      const result = await fetchBrands()
      setBrands(result)
    })()
  }, [])

  return {
    brands,
    setBrands,
  }
}

export default useFetchBrands
